import React, { useContext } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import { EditCustomerContext, IEditCustomerContext } from '../editCustomerState/editCustomerContext';
import style from './ControlPanel.module.scss';

export const EditCustomerControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm, initialFormData } = useContext<IEditCustomerContext>(EditCustomerContext);
	const hasMainFormAccess = useRoleAccess([UserRoles.SUPER_USER]);
	const hasLocalizationFormAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const hasStyleFormAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const hasBpaFormAccess = useRoleAccess([UserRoles.SUPER_USER]);

	return (
		<div className={style.container} data-test="EditCustomerControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
				disabled={!hasMainFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('localizationForm')}
				isActive={visibleForm === 'localizationForm'}
				btnName="localizationBookmark"
				disabled={!hasLocalizationFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('styleForm')}
				isActive={visibleForm === 'styleForm'}
				btnName="styleBookmark"
				disabled={!hasStyleFormAccess}
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('bpaForm')}
				isActive={visibleForm === 'bpaForm'}
				btnName="bpaBookmark"
				disabled={!hasBpaFormAccess || !initialFormData?.isActiveBpa}
			/>
		</div>
	);
};
